/* global axios */
import ApiClient from './ApiClient';

// Informes › Redes · seguidores por cuenta (Victor 2026-06-02). Solo lectura;
// refresh() consulta Meta en el server y devuelve la matriz fresca.
class SocialStatsAPI extends ApiClient {
  constructor() {
    super('social_stats', { accountScoped: true, apiVersion: 'v2' });
  }

  get() {
    return axios.get(this.url);
  }

  refresh() {
    return axios.post(`${this.url}/refresh`);
  }
}

export default new SocialStatsAPI();
